var voted_users_rtlignore_default = {
  "container": "HAOF9",
  "webview": "_4F2-K",
  "avatar_list": "G-icC",
  "avatar": "h1Qiz",
  "user_avatar": "IHaH-",
  "modal": "p8q0y",
  "voted_users_modal": "CNVTo",
  "overlay": "KMdsN",
  "user_card": "SladV",
  "user_name": "ooxi5",
  "voted_users_modal_header": "jQYvD",
  "cta": "U822y",
  "close_icon": "LLXSD",
  "title": "NuLS1",
  "member_list_container": "dcHA5",
  "member_list": "G8ldR",
  "loader": "GQifK",
  "anonymous_counter": "Dm-Uj",
  "spinner": "YXqY8",
  "spin": "eDnAu"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
